import React from 'react';
import { View, Text, Image, StyleSheet, Pressable, Dimensions, Linking } from 'react-native';
import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

interface MobileLandingScreenProps {
    onContinue: () => void;
}

const MobileLandingScreen: React.FC<MobileLandingScreenProps> = ({ onContinue }) => {
    return (
        <View style={styles.container}>
            {/* Header */}
            <View style={styles.header}>
                <MaterialCommunityIcons name="menu" size={28} color="#333" />
                <View style={styles.logoContainer}>
                    <Image
                        source={require('../assets/images/logo1.png')}
                        style={styles.logo}
                        resizeMode="contain"
                    />
                    <Text style={styles.logoText}>SnapCamp</Text>
                </View>
                <View style={{ width: 28 }} /> {/* Spacer to center logo */}
            </View>

            {/* Content Container */}
            <View style={styles.content}>
                <Text style={styles.title}>Find the perfect camp for your children!</Text>
                <Text style={styles.subtitle}>
                    SnapCamp connects camp organizers directly with parents looking for the perfect activities for their children!
                </Text>

                <Image
                    source={require('../assets/images/camping_kids.png')}
                    style={styles.illustration}
                    resizeMode="contain"
                />

                {/* Download Buttons */}
                <View style={styles.buttonContainer}>
                    <Pressable
                        style={[styles.downloadButton, styles.appStoreButton]}
                        onPress={() => Linking.openURL('https://apps.apple.com')}
                    >
                        <MaterialCommunityIcons name="apple" size={24} color="white" />
                        <View style={styles.buttonTextContainer}>
                            <Text style={styles.buttonLabel}>Download on the</Text>
                            <Text style={styles.buttonMainText}>App Store</Text>
                        </View>
                    </Pressable>

                    <Pressable
                        style={[styles.downloadButton, styles.playStoreButton]}
                        onPress={() => Linking.openURL('https://play.google.com')}
                    >
                        <MaterialCommunityIcons name="google-play" size={24} color="white" />
                        <View style={styles.buttonTextContainer}>
                            <Text style={styles.buttonLabel}>Get it on</Text>
                            <Text style={styles.buttonMainText}>Google Play</Text>
                        </View>
                    </Pressable>
                </View>

                {/* Bypass Link */}
                <Pressable onPress={onContinue} style={styles.bypassContainer}>
                    <Text style={styles.bypassText}>Continue to website (not mobile-optimized)</Text>
                </Pressable>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#F9FAFB',
        height: SCREEN_HEIGHT,
        width: SCREEN_WIDTH,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingHorizontal: 20,
        paddingTop: 50,
        paddingBottom: 20,
        backgroundColor: '#FFF',
    },
    logoContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    logo: {
        width: 32,
        height: 32,
    },
    logoText: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#333',
    },
    content: {
        flex: 1,
        alignItems: 'center',
        paddingHorizontal: 30,
        paddingTop: 40,
    },
    title: {
        fontSize: 32,
        fontWeight: '800',
        color: '#111827',
        textAlign: 'center',
        marginBottom: 16,
    },
    subtitle: {
        fontSize: 16,
        color: '#4B5563',
        textAlign: 'center',
        lineHeight: 24,
        marginBottom: 40,
    },
    illustration: {
        width: SCREEN_WIDTH * 0.85,
        height: SCREEN_WIDTH * 0.7,
        marginBottom: 50,
    },
    buttonContainer: {
        width: '100%',
        gap: 16,
        marginBottom: 40,
    },
    downloadButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 20,
        borderRadius: 14,
        gap: 12,
        width: '100%',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 10,
        elevation: 5,
    },
    appStoreButton: {
        backgroundColor: '#3B82F6', // Blue variant to match mockup
    },
    playStoreButton: {
        backgroundColor: '#60A5FA', // Lighter blue variant to match mockup
    },
    buttonTextContainer: {
        alignItems: 'flex-start',
    },
    buttonLabel: {
        color: 'white',
        fontSize: 10,
        fontWeight: '500',
    },
    buttonMainText: {
        color: 'white',
        fontSize: 18,
        fontWeight: 'bold',
    },
    bypassContainer: {
        paddingVertical: 10,
    },
    bypassText: {
        color: '#6B7280',
        fontSize: 14,
        textDecorationLine: 'underline',
    },
});

export default MobileLandingScreen;
